import { TExamHistologicalResultValue } from 'constants/products';
import { EnumExamHistologicalResult } from 'generated/graphql';
import * as yup from 'yup';
import {
  FORM_ERROR_MESSAGE,
  getEndOfToday,
  MAX_LENGTH,
  MIN_DATE,
  POSITIVE_INTEGER_WITHOUT_ZERO_REGEX,
} from 'yupHelper';

export const getValidationSchema = () =>
  yup.object({
    examDate: yup
      .date()
      .min(MIN_DATE, FORM_ERROR_MESSAGE.MIN_DATE)
      .max(getEndOfToday(), FORM_ERROR_MESSAGE.DATE_FROM_PAST)
      .typeError(FORM_ERROR_MESSAGE.INVALID_DATE)
      .required(FORM_ERROR_MESSAGE.REQUIRED),
    physician: yup.object().nullable(),
    priority: yup.object().required(FORM_ERROR_MESSAGE.REQUIRED).nullable(),
    clinicalIndication: yup
      .string()
      .max(MAX_LENGTH.TEXT_AREA, FORM_ERROR_MESSAGE.MAX)
      .required(FORM_ERROR_MESSAGE.REQUIRED),
    histologicalResult: yup
      .object({
        value: yup
          .mixed<TExamHistologicalResultValue>()
          .oneOf(Object.values(EnumExamHistologicalResult)),
      })
      .notRequired()
      .nullable(),
    glucoseLevel: yup
      .string()
      .matches(POSITIVE_INTEGER_WITHOUT_ZERO_REGEX, {
        message: FORM_ERROR_MESSAGE.POSITIVE_INTEGER_WITHOUT_ZERO_REGEX,
        excludeEmptyString: true,
      })
      .test(
        'glucoseLevelRange',
        FORM_ERROR_MESSAGE.GLUCOSE_LEVEL_RANGE,
        (value) => {
          if (!value) return true; // Allow empty value
          const numValue = parseInt(value, 10);
          return numValue >= 1 && numValue <= 2000;
        },
      ),
    ceaLevel: yup
      .string()
      .matches(POSITIVE_INTEGER_WITHOUT_ZERO_REGEX, {
        message: FORM_ERROR_MESSAGE.POSITIVE_INTEGER_WITHOUT_ZERO_REGEX,
        excludeEmptyString: true,
      })
      .test('ceaLevelRange', FORM_ERROR_MESSAGE.CEA_LEVEL_RANGE, (value) => {
        if (!value) return true; // Allow empty value
        const numValue = parseInt(value, 10);
        return numValue >= 1 && numValue <= 20000;
      }),
  });
